import React from 'react';

import InsertMenuToolbarContent from './InsertMenuToolbarContent';
import { InsertRightIcon } from '@milanote/roma-icons';
import RomaToolbarIcon from '../../../roma/RomaToolbarIcon';
import { Popover } from '@milanote/roma';
import useToolbarPopover from '../../../../hooks/useToolbarPopover';
import { Button } from 'react-aria-components';
import ToolbarTool from '../../../ToolbarTool';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import { useBoardLinkManager } from '../../../../../../components/tiptapEditor/extensions/boardLinks/useBoardLinkManager';
import { useBoardLinkPopupManager } from '../../../../../../components/tiptapEditor/extensions/boardLinks/useBoardLinkPopupManager';

type InsertMenuToolProps = {
    name?: string;
    element?: ImMNElement;
};

const InsertMenuTool: React.FC<InsertMenuToolProps> = ({ name = 'Insert', element, ...toolProps }) => {
    const { isOpen, onOpenChange } = useToolbarPopover();
    const boardLinkManager = useBoardLinkManager();
    const {
        openPopup: openBoardLinkPopup,
        closePopup: closeBoardLinkPopup,
        popupElement: boardLinkPopup,
    } = useBoardLinkPopupManager(boardLinkManager);

    const handleInsertMenuOpenChange = (open: boolean) => {
        onOpenChange(open);

        if (!open) return;

        closeBoardLinkPopup();
    };

    const dispatchClosePopup = () => onOpenChange(false);

    return (
        <div className="InsertMenu ToolbarPopupTool">
            <Popover.MenuTrigger isOpen={isOpen} onOpenChange={handleInsertMenuOpenChange}>
                <Button className="Button" aria-label={name}>
                    <ToolbarTool {...toolProps} name={name} isOpen={isOpen} tooltipEnabled={!isOpen}>
                        <RomaToolbarIcon icon={InsertRightIcon} iconClassName="size-5" />
                    </ToolbarTool>
                </Button>
                <Popover className="w-75" placement="end top" offset={4} crossOffset={9}>
                    <InsertMenuToolbarContent
                        closePopup={dispatchClosePopup}
                        size={'md'}
                        onLinkBoard={openBoardLinkPopup}
                        element={element}
                    />
                </Popover>
            </Popover.MenuTrigger>
            {boardLinkPopup}
        </div>
    );
};

export default InsertMenuTool;
